String.prototype.removeHTMLTags = String.prototype.removeHTMLTags || function () {
    'use strict';
    return this.replace(/(<([^>]+)>)/gi, '');
};